import { getCurrencySymbol } from '../../../../../../utils/getCurrencySymbol'
import styles from './OrderInfo.module.scss'
import React, { useState } from 'react'

import { ReactComponent as Chevrone } from '../../../../../../icons/chevrone.svg'

export const OrderInfo = ({
  countSalesStatus,
  bindingProduct,
  products,
  promoRes,
  currency
}) => {
  const [showProd, setShowProd] = useState(false)

  const currentProducts = promoRes?.success ? promoRes.products : products

  return (
    <div className={styles.orderInfoWrapper}>
      {!countSalesStatus && !bindingProduct && (
        <div data-testid="products-title" className={styles.productsTitle}>
          <div data-testid="product-amount" className={styles.prodAmount}>
            Состав заказа <span>{products?.length || 0}</span>
          </div>
          <div
            data-testid="toggle-products-button"
            className={styles.showProdBtn}
            onClick={() => setShowProd(!showProd)}
            style={showProd ? { transform: 'rotate(180deg)' } : {}}
          >
            <Chevrone />
          </div>
        </div>
      )}
      {!countSalesStatus &&
        showProd &&
        currentProducts?.map((el, i) => (
          <>
            <div
              data-testid={`product-row-${i}`}
              className={styles.productsRow}
              key={i}
            >
              <div
                data-testid={`product-row-${i}`}
                className={styles.leftSide}
                key={i}
              >
                <div
                  data-testid={`product-title-${i}`}
                  className={styles.productTitle}
                >
                  {!el.name
                    ? !el.product_info.custom_name
                      ? el.product_info.name
                      : el.product_info.custom_name
                    : el.name}
                </div>

                <div
                  data-testid={`product-quantity-${i}`}
                  className={styles.amount}
                >
                  {el.quantity} шт.
                </div>
              </div>

              {!promoRes?.success ? (
                <div
                  data-testid={`product-price-${i}`}
                  className={styles.price}
                >
                  {(!el.price
                    ? el.product_info.price
                    : el.price
                  )?.toLocaleString('ru-RU')}{' '}
                  {getCurrencySymbol(currency)}
                </div>
              ) : (
                <div className={styles.promoPricebox}>
                  <div
                    data-testid={`product-price-${i}`}
                    className={styles.promoPrice}
                  >
                    {el.new_price < 0
                      ? 0
                      : el.new_price?.toLocaleString('ru-RU')}{' '}
                    {getCurrencySymbol(currency)}
                  </div>
                  {el.price_difference !== 0 && (
                    <div>
                      <div
                        data-testid={`old-price-${i}`}
                        className={styles.oldPrice}
                      >
                        {el.price?.toLocaleString('ru-RU')}{' '}
                        {getCurrencySymbol(currency)}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </>
        ))}
    </div>
  )
}
